import { render, staticRenderFns } from "./crearAgenteDeComercio.vue?vue&type=template&id=08c867a8"
import script from "./crearAgenteDeComercio.vue?vue&type=script&lang=js"
export * from "./crearAgenteDeComercio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports